import { render } from "./FilterVoucher.vue?vue&type=template&id=22cbf644&scoped=true"
import script from "./FilterVoucher.vue?vue&type=script&lang=js"
export * from "./FilterVoucher.vue?vue&type=script&lang=js"

import "./FilterVoucher.vue?vue&type=style&index=0&id=22cbf644&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cbf644"]])

export default __exports__